<template>
  <div class="row">
    <div class="col-6 col-lg-12 mt-4">
      <iframe src="https://nowpayments.io/embeds/donation-widget?api_key=010cb782-b3bc-414c-aebe-083222ebb1a7" width="346" height="623" frameborder="0" scrolling="no" style="overflow-y: hidden;">
        Can't load widget
      </iframe>
    </div>
    <div class="col-12 col-lg-12 mt-4 mb-5">
      <div>
      <el-button type="info" size="mini" class="mr-2 cursor-pointer" circle @click="copyTronToClipboard">
        <i class="el-icon-document-copy"></i>
      </el-button>
      <img src="../assets/crypto/tron-trx-logo.svg" alt="TRON" style="width: 24px; height: 24px; margin-right: 8px;">

      TRC20 (Tron): <code class="cursor-pointer" @click="showTronQR">{{ trc20Url }}</code>
      </div>
      <div>
      <el-button type="info" size="mini" class="mr-2 cursor-pointer" circle @click="copyBtcToClipboard">
        <i class="el-icon-document-copy"></i>
      </el-button>

      <img src="../assets/crypto/bitcoin-btc-logo.svg" alt="Bitcoin"
           style="width: 24px; height: 24px; margin-right: 8px;">

      BTC: <code class="cursor-pointer" @click="showBtcQR">{{ btcUrl }}</code>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";

export default {
  name: 'pc-crypto-donation',
  created() {
    this.generateQRCodes()
  },

  data() {
    return {
      trc20Url: "TCkJ8W9hNsNVBtKoGQUBTT7DjFjRjStktw",
      btcUrl: "bc1qlk0dv7ks0dl2hw90fgu2pwgaea5suyg7hr8yap",
      tronQR: '',
      btcQR: '',
    }
  },
  methods: {
    copyTronToClipboard() {
      navigator.clipboard.writeText(this.trc20Url);
    },
    copyBtcToClipboard() {
      navigator.clipboard.writeText(this.btcUrl);
    },
    async generateQRCodes() {
      try {
        this.tronQR = await QRCode.toDataURL(this.trc20Url, {
          width: 180,
          margin: 2
        })

        this.btcQR = await QRCode.toDataURL(this.btcUrl, {
          width: 180,
          margin: 2
        })
      } catch (err) {
        console.error(err)
      }
    },
    showTronQR() {
      this.$alert(
          `<div class="text-center">
          <img src="${this.tronQR}" alt="TRON QR Code">
          <code class="mt-3">${this.trc20Url}</code>

        </div>`,
          'TRON Address QR Code',
          {
            dangerouslyUseHTMLString: true,
            center: true,
            customClass: 'qr-dialog'
          }
      )
    },
    showBtcQR() {
      this.$alert(
          `<div class="text-center">
          <img src="${this.btcQR}" alt="Bitcoin QR Code">
          <code class="mt-3">${this.btcUrl}</code>

        </div>`,
          'Bitcoin Address QR Code',
          {
            dangerouslyUseHTMLString: true,
            center: true,
            customClass: 'qr-dialog'
          }
      )
    },
  }

}
</script>
<style scoped>
@media (max-width: 577px) {
}

</style>
<style>
/* Chrome, Safari, Edge, Opera */
.input-amount input::-webkit-outer-spin-button,
.input-amount input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* this is for Firefox */
.input-amount input[type=number] {
  -moz-appearance: textfield;
}

.cursor-pointer {
  cursor: pointer;
}

</style>